import Service from "../service";
import initAlmaNativeVideo from "./native-video";
class NativeAdsService extends Service {
    constructor(config, context) {
        super("NativeAds", context);
        this.configuration = config;
    }
    getNativeParams() {
        return this.configuration.defaults.nativeFields;
    }
    async renderNativeAd(adObject, templateName) {
        this.logger.logInfo(`Rendering tag ${adObject.targetId} from placement ${adObject.tagId} with template ${templateName}`);
        const template = this.configuration.templates.find((t) => t.name === templateName);
        if (!template) {
            this.logger.logError(`Could not find template with name ${templateName}`);
            return;
        }
        this.logger.logInfo(`Found template ${template.name}`);
        const wrapperId = `${adObject.targetId}_${Math.random()
            .toString(36)
            .substr(2, 5)}`;
        this.logger.logInfo(`Created random native wrapper ${wrapperId}`);
        const targetElement = window.document.getElementById(adObject.targetId);
        const nativeContent = template?.buildContent(adObject, wrapperId);
        if (!targetElement) {
            this.logger.logError(`Could not find target element ${adObject.targetId} for native rendering`);
            return;
        }
        if (!nativeContent) {
            this.logger.logError(`Could not render content for native template ${template.name} for tag ${adObject.targetId}`);
            return;
        }
        this.logger.logInfo(`Rendering native for tag ${adObject.targetId} with template ${template.name} and wrapper ${wrapperId}`);
        targetElement.innerHTML = nativeContent;
        const nativeStyles = template?.buildStyles(wrapperId);
        if (!nativeStyles) {
            this.logger.logError(`Could not render styles for native template ${template.name} for tag ${adObject.targetId}`);
            return;
        }
        const headE = window.document.head || window.document.getElementsByTagName("head")[0];
        const styleTarget = window.document.getElementById(adObject.targetId) || headE;
        const styleE = window.document.createElement("style");
        this.logger.logInfo(`Appending native styles for tag ${adObject.targetId} with template ${template.name} and wrapper ${wrapperId}`);
        styleE.appendChild(window.document.createTextNode(nativeStyles));
        styleTarget.appendChild(styleE);
        // Native video
        this.logger.logInfo(`Handle native video`);
        const { native } = adObject;
        const videoElementId = `${wrapperId}_almavideo-native`;
        const videoE = window.document.getElementById(videoElementId);
        if (native.video?.content && !videoE) {
            this.logger.logError(`Video in adObject for non supported template`);
        }
        if (native.video?.content && videoE) {
            const vast = adObject.native.video && adObject.native.video.content
                ? adObject.native.video && adObject.native.video.content
                : "";
            const posterImage = adObject.native.image && adObject.native.image.url
                ? adObject.native.image && adObject.native.image.url
                : "https://d14evu1q67bpdr.cloudfront.net/video/jw/blank.gif";
            await initAlmaNativeVideo(videoElementId, vast, posterImage);
        }
        this.logger.logInfo(`Attaching template click tracker`);
        template.attachClick(adObject, wrapperId, videoElementId);
        // Attach ast.js things
        this.logger.logInfo(`Attaching ast.js click & impression trackers`);
        window.apntag.fireImpressionTrackers(adObject);
    }
}
export default NativeAdsService;
//# sourceMappingURL=native-ads.js.map